import React, {useEffect} from 'react';
import Helmet from "react-helmet";
import ContactsSection from "../MainPage/MainPageSections/ContactsSection";
import './Article.scss';
import ToTopBtn from '../../Common/ToTopBtn';

const ArticlePage = ({toggleMenu}) => {
   useEffect(() => {
      toggleMenu(false);
   },[]);
    return (
      <>
        <Helmet>
          <title>Статья</title>
          <meta name="description" content="Article component" />
        </Helmet>
        <section className="article">
          <div className="wrapper">
            <div className="social">
              <div className="social__Way">
                <div className="social__box">
                  <button className="social__item">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 0C6.71581 0 0 6.71581 0 15C0 23.2842 6.71581 30 15 30C23.2842 30 30 23.2842 30 15C30 6.71581 23.2842 0 15 0ZM21.5047 16.9827C21.6227 17.1287 21.9035 17.4131 22.3476 17.8365H22.3579L22.3683 17.8466L22.3786 17.8572L22.3996 17.8779C23.3779 18.7868 24.0404 19.5537 24.3875 20.1782C24.4085 20.2125 24.431 20.2563 24.4553 20.3083C24.4793 20.3604 24.5037 20.4522 24.528 20.5839C24.552 20.7163 24.5502 20.8337 24.5228 20.9377C24.4952 21.0414 24.4085 21.1376 24.2628 21.2239C24.1171 21.3109 23.9123 21.3541 23.6486 21.3541L20.9842 21.3961C20.8179 21.4308 20.6235 21.4134 20.4014 21.3441C20.1791 21.2744 19.999 21.1981 19.8603 21.115L19.6519 20.9897C19.4435 20.844 19.2008 20.622 18.9234 20.3239C18.6457 20.0255 18.4081 19.7566 18.2104 19.5172C18.0127 19.2778 17.8009 19.077 17.5752 18.9133C17.3495 18.7503 17.1536 18.6965 16.9872 18.7521C16.9666 18.7594 16.9386 18.7716 16.9039 18.7886C16.8689 18.806 16.8102 18.8559 16.7269 18.9395C16.6435 19.0229 16.569 19.1254 16.503 19.2464C16.437 19.3681 16.378 19.5485 16.3259 19.7879C16.2739 20.027 16.2511 20.2962 16.2584 20.5946C16.2584 20.6983 16.2459 20.7941 16.2219 20.8808C16.1976 20.9675 16.1714 21.0317 16.1437 21.0731L16.1021 21.1251C15.977 21.2574 15.7933 21.3334 15.5506 21.3541H14.3536C13.8608 21.3821 13.3544 21.3249 12.8342 21.1826C12.314 21.0399 11.8575 20.8565 11.4657 20.6308C11.0733 20.4057 10.7162 20.1766 10.3937 19.9442C10.071 19.7115 9.82641 19.5123 9.66002 19.3459L9.39994 19.0959C9.33059 19.0268 9.23507 18.9225 9.1137 18.7835C8.99233 18.6448 8.74442 18.3293 8.36967 17.8365C7.99491 17.3438 7.62715 16.8202 7.26639 16.2648C6.90562 15.7097 6.48067 14.9775 5.99124 14.0686C5.50211 13.16 5.04948 12.2164 4.63305 11.2378C4.59138 11.1271 4.57039 11.0334 4.57039 10.9571C4.57039 10.881 4.58073 10.8254 4.60172 10.7904L4.64339 10.728C4.74742 10.596 4.94515 10.53 5.23656 10.53L8.08829 10.5093C8.17164 10.5233 8.25134 10.5458 8.32769 10.5771C8.40404 10.6082 8.45971 10.6377 8.49438 10.6654L8.5464 10.6967C8.65743 10.7733 8.74047 10.8841 8.79613 11.0298C8.93484 11.3771 9.09454 11.7361 9.27492 12.1072C9.45531 12.4783 9.59766 12.7612 9.7017 12.9553L9.86809 13.2573C10.0692 13.6734 10.2635 14.0345 10.4509 14.3396C10.6386 14.645 10.8065 14.8829 10.9559 15.0526C11.1049 15.2227 11.2488 15.3565 11.3878 15.4532C11.5265 15.5506 11.6445 15.5992 11.7419 15.5992C11.8389 15.5992 11.9326 15.5819 12.0229 15.5472C12.0366 15.5402 12.054 15.5229 12.075 15.4952C12.0959 15.4675 12.1373 15.3912 12.2 15.2659C12.2623 15.1411 12.3092 14.9781 12.3405 14.7767C12.3718 14.576 12.4047 14.2949 12.4394 13.9341C12.474 13.5731 12.474 13.1396 12.4394 12.6331C12.4254 12.3554 12.394 12.1023 12.3457 11.8733C12.297 11.6445 12.2483 11.4848 12.2 11.3945L12.1373 11.2698C11.9639 11.034 11.6692 10.8847 11.2527 10.822C11.1624 10.8086 11.1797 10.7253 11.3048 10.5726C11.4228 10.4406 11.5545 10.3368 11.7002 10.2602C12.068 10.0801 12.8972 9.99676 14.1878 10.0101C14.7567 10.0174 15.2251 10.0622 15.5929 10.1455C15.7316 10.1805 15.8478 10.227 15.9415 10.286C16.0351 10.3447 16.1063 10.4284 16.155 10.5355C16.2034 10.6431 16.2399 10.7542 16.2642 10.8686C16.2885 10.9832 16.3007 11.1414 16.3007 11.3422C16.3007 11.5435 16.2974 11.7346 16.2904 11.9146C16.2834 12.095 16.2748 12.3399 16.2645 12.6483C16.2542 12.9571 16.2487 13.2436 16.2487 13.5071C16.2487 13.5837 16.2453 13.7291 16.2383 13.9442C16.2313 14.1595 16.2292 14.3259 16.2332 14.4436C16.2365 14.5617 16.2487 14.7025 16.2694 14.8652C16.2904 15.0283 16.3302 15.164 16.3892 15.271C16.4479 15.3787 16.5261 15.4636 16.6234 15.5259C16.6788 15.5402 16.7378 15.5539 16.8005 15.5679C16.8628 15.5816 16.9529 15.5439 17.0709 15.4532C17.1886 15.3632 17.3206 15.2433 17.4663 15.0943C17.612 14.9456 17.7924 14.7132 18.0075 14.3971C18.2222 14.082 18.4583 13.7087 18.715 13.2783C19.1314 12.5568 19.5026 11.7759 19.8286 10.9364C19.8563 10.8667 19.891 10.8062 19.9327 10.7542C19.9743 10.7019 20.0124 10.6654 20.047 10.6447L20.0887 10.6133C20.1024 10.6063 20.1197 10.5978 20.1407 10.5875C20.1617 10.5774 20.2067 10.5668 20.2761 10.5562C20.3455 10.5461 20.4148 10.5443 20.4845 10.5513L23.4819 10.53C23.7523 10.4956 23.9744 10.5041 24.1478 10.5558C24.3212 10.6079 24.4288 10.6654 24.4705 10.7277L24.5332 10.8317C24.6926 11.2762 24.1724 12.2955 22.9721 13.8915C22.8054 14.1139 22.5797 14.409 22.2956 14.7764C21.7544 15.4706 21.4423 15.925 21.3596 16.1407C21.241 16.4245 21.2896 16.7056 21.5047 16.9827Z"
                        fill="#C4C4C4"
                      />
                    </svg>
                  </button>
                  <button className="social__item">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.9066 7.44531H11.0151C9.0403 7.44531 7.43359 9.05202 7.43359 11.0268V18.9907C7.43359 20.9654 9.0403 22.5722 11.0151 22.5722H18.9066C20.8813 22.5722 22.488 20.9654 22.488 18.9907V11.0268C22.488 9.05202 20.8813 7.44531 18.9066 7.44531ZM14.9759 19.7773C12.299 19.7773 10.1214 17.6228 10.1214 14.9745C10.1214 12.3263 12.2993 10.1717 14.9759 10.1717C17.6524 10.1717 19.8304 12.3263 19.8304 14.9745C19.8304 17.6228 17.6527 19.7773 14.9759 19.7773ZM19.9168 11.1174C19.2859 11.1174 18.7745 10.6061 18.7745 9.97522C18.7745 9.34434 19.2859 8.83301 19.9168 8.83301C20.5476 8.83301 21.059 9.34434 21.059 9.97522C21.059 10.6061 20.5476 11.1174 19.9168 11.1174Z"
                        fill="#C4C4C4"
                      />
                      <path
                        d="M15 0C6.71581 0 0 6.71581 0 15C0 23.2842 6.71581 30 15 30C23.2842 30 30 23.2842 30 15C30 6.71581 23.2842 0 15 0ZM24.2615 18.9888C24.2615 21.9406 21.86 24.3418 18.9085 24.3418H11.017C8.06518 24.3418 5.66394 21.9403 5.66394 18.9888V11.0249C5.66394 8.07309 8.06548 5.67184 11.017 5.67184H18.9085C21.8603 5.67184 24.2615 8.07339 24.2615 11.0249V18.9888Z"
                        fill="#C4C4C4"
                      />
                      <path
                        d="M11.9385 15.0221C11.9385 16.7241 13.2997 18.1084 14.973 18.1084C16.6464 18.1084 18.0076 16.724 18.0076 15.0221C18.0076 13.3202 16.6464 11.9359 14.973 11.9359C13.2997 11.9359 11.9385 13.3202 11.9385 15.0221Z"
                        fill="#C4C4C4"
                      />
                    </svg>
                  </button>
                  <button className="social__item">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 0C6.71581 0 0 6.71581 0 15C0 23.2842 6.71581 30 15 30C23.2842 30 30 23.2842 30 15C30 6.71581 23.2842 0 15 0ZM19.407 8.59781C18.694 8.59781 17.9765 8.59781 17.2638 8.59781C16.8126 8.5686 16.3472 8.91294 16.2648 9.36405C16.2551 10.1449 16.2599 10.9254 16.2599 11.7063C17.3072 11.7111 18.3549 11.7063 19.4025 11.7111C19.3249 12.8409 19.1844 13.9661 19.0195 15.0815C18.0933 15.0913 17.167 15.0815 16.2408 15.0864C16.231 18.4178 16.2456 21.7444 16.2359 25.0761C14.8586 25.081 13.4864 25.0713 12.109 25.081C12.0847 21.7496 12.109 18.4181 12.0944 15.0864C11.4252 15.0815 10.7511 15.0913 10.0819 15.0815C10.0868 13.9612 10.0819 12.8412 10.0819 11.7257C10.7511 11.716 11.4252 11.7257 12.0944 11.7209C12.1139 10.6346 12.075 9.54352 12.1139 8.45727C12.1866 7.58913 12.5115 6.72128 13.1566 6.12478C13.9375 5.38287 15.0429 5.1307 16.0905 5.1015C17.1962 5.09176 18.3019 5.09663 19.4073 5.09663C19.4119 6.26531 19.4119 7.42912 19.407 8.59781Z"
                        fill="#C4C4C4"
                      />
                    </svg>
                  </button>
                  <div className="social__text">Поделиться</div>
                </div>
              </div>
              <div className="article__box">
                <h2 className="article__title">
                  Позиционирование компании. Основа маркетинга и фундамент в конкурентной борьбе.
                </h2>
                {/*<img src={require("../../../assets/images/article/article__supImg.jpg")} alt="" className="article__supImg"/>*/}
                <div className="article__body">
                  <div className="article__paragraph">
                    <p className="article__text">
                      Эти 3 базовых вопроса мы задаём нашим клиентам на старте сотрудничества. Мы
                      помогаем клиенту сформулировать эти базовые понятия, после чего уже начинаем
                      работать над маркетинговыми площадками и рекламными инструментами.
                      <br />
                      <br />
                      Мы считаем, формирование стратегии продвижения продукта начинается с 3
                      вопросов:
                      <br />
                      <br />
                      В чём уникальность продукта (оffer)?
                      <br />
                      Чьи и какие потребности он удовлетворяет (целевая аудитория)?
                      <br />
                      Чем компания отличается от других (позиционирование)?
                      <br />
                      Мы хотим поделиться своими взглядами на то, что такое позиционирование
                      компании, в чём его важность и почему большинство компаний не работает над
                      ним. Затронем также основные принципы и этапы формирования позиционирования.
                      <br />
                      Позиционирование относится больше к стратегическому маркетингу, чем к digital,
                      тем не менее мы часто участвуем в работе над позиционированием наших
                      компаний-клиентов.
                      <br />
                      <br />
                      Около 1,5 лет назад мы впервые задумались над позиционированием агентства и с
                      тех пор постоянно работаем над этим. Мы неплохо продвинулись в этом вопросе,
                      но стоит признать, что до успеха нам ещё далеко. По-другому и не может быть,
                      потому что позиционирование – это постоянный процесс, его невозможно
                      завершить. Ниже постараемся объяснить почему.
                      <br />
                      <br />В статье мы постоянно будем опираться на собственный опыт работы над
                      позиционированием и примеры из нашей сферы.
                    </p>
                    <div className="article__textBold">
                      К нам обратился клиент – новый салон маникюра в Москве. Салон только открылся,
                      ни сайта, ни даже групп в социальных сетях нет. Расходы на аренду и заработную
                      плату идут, нужно как можно быстрее рассказать о себе и привлечь клиентов.
                    </div>
                    <h3 className="article__minTitle">Кейс</h3>
                    <p className="article__text">
                      К нам обратился клиент – новый салон маникюра в Москве. Салон только открылся,
                      ни сайта, ни даже групп в социальных сетях нет. Расходы на аренду и заработную
                      плату идут, нужно как можно быстрее рассказать о себе и привлечь клиентов.
                      <br />
                      <br />
                      Решили использовать лид-формы в Facebook и Вконтакте. Продумали выгодную
                      акцию, эффектно её описали, нарисовали яркую графику. Настроились на аудиторию
                      женщин, которые живут или работают в радиусе 2 км. от салона.
                      <br />
                      <br />
                      Получили стоимость привлечения клиента – около 250 рублей, при стоимости
                      услуги в 1000 рублей. При качественном оказании услуги клиент может обратиться
                      в маникюрный салон ещё ни один раз, принеся дополнительную прибыль. В общем,
                      если брать в расчёт LTV и потенциальные рекомендации, канал привлечения
                      клиентов получился выгодным.
                    </p>
                  </div>
                  <div className="article__more">
                    <div className="article__moreTitle">Читайте еще</div>
                    <div className="article__moreItems">
                      <div className="article__moreItem">
                        <div className="entry">
                          {/*<img src={require("../../../assets/images/article/entry__img.jpg")} alt="" className="entry__img"/>*/}
                          <div className="entry__title">
                            Как мы сделали ребрендинг крупной мебельной компании
                          </div>
                        </div>
                      </div>
                      <div className="article__moreItem">
                        <div className="entry">
                          {/*<img src={require("../../../assets/images/article/entry__img.jpg")} alt="" className="entry__img"/>*/}
                          <div className="entry__title">
                            Как мы сделали ребрендинг крупной мебельной компании
                          </div>
                        </div>
                      </div>
                      <div className="article__moreItem">
                        <div className="entry">
                          {/*<img src={require("../../../assets/images/article/entry__img.jpg")} alt="" className="entry__img"/>*/}
                          <div className="entry__title">
                            Как мы сделали ребрендинг крупной мебельной компании
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*<img src={require("../../../assets/images/article/article__subImg.jpg")} alt="" className="article__subImg"/>*/}
                <div className="articleMore">
                  <div className="articleMore__box">
                    <h3 className="articleMore__title">Следущие статьи</h3>
                    <div className="articleMore__gallery">
                      <div className="articleMore__item">
                        <div className="entry">
                          {/*<img src="img/entry__img.jpg" alt="" className="entry__img"/>*/}
                          <div className="entry__title">
                            Как мы сделали ребрендинг крупной мебельной компании
                          </div>
                        </div>
                      </div>
                      <div className="articleMore__item">
                        <div className="entry">
                          {/*<img src="img/entry__img.jpg" alt="" className="entry__img"/>*/}
                          <div className="entry__title">
                            Как мы сделали ребрендинг крупной мебельной компании
                          </div>
                        </div>
                      </div>
                      <div className="articleMore__item">
                        <div className="entry">
                          {/*<img src="img/entry__img.jpg" alt="" className="entry__img"/>*/}
                          <div className="entry__title">
                            Как мы сделали ребрендинг крупной мебельной компании
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="articleMore__arrows"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ContactsSection />
        {/* <ToTopBtn /> */}
      </>
    );
}

export default ArticlePage;
